<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="usuarios"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Usuarios web</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                <v-btn color="green" dark class="mb-2 mx-2" @click="descargarExcel()">Excel</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="nombre"
                          label="Nombre"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-select
                          v-model="cuenta"
                          :items="itemsCuenta"
                          label="Cuenta"
                        ></v-select>
                      </v-col>
                      <v-col class="pr-0 py-0" cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="email"
                          label="Correo"
                          v-if="editedIndex == -1"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="password"
                          label="Contraseña"
                          type="password"
                          hide-details
                          v-if="editedIndex == -1"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="idTelegram"
                          label="Chat id telegram"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <div
                          class="red--text"
                          v-for="v in validaMensaje"
                          :key="v"
                          v-text="v"
                        ></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-btn color="primary" @click="cambiarContraseñaFirebase()" v-if="editedIndex == 1"
                    >Restablecer contraseña</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="close">CANCELAR</v-btn>
                  <v-btn
                    color="success"
                    @click="crearUsuario()"
                    v-if="editedIndex == -1"
                    >Guardar</v-btn
                  >
                  <v-btn color="success" @click="actualizar()" v-else
                    >Actualizar</v-btn
                  >
                </v-card-actions>
              </v-card>

              <!-- PreLoader -->
              <v-overlay v-model="overlayNuevo" z-index="0">
                <lottie-player
                  v-if="true"
                  src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
                  background="transparent"
                  speed="1"
                  style="width: 300px; height: 300px"
                  loop
                  autoplay
                ></lottie-player>
              </v-overlay>
            </v-dialog>
          </v-toolbar>
        </template>
        <!-- activar, desactivar cuenta -->
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small @click="editItem(item)"> edit </v-icon>
          <v-icon
            small
            @click="DesactivarUsuario(item)"
            v-if="item.estado == 'activo'"
          >
            check
          </v-icon>
          <v-icon small @click="ActivarUsuario(item)" v-else> block </v-icon>
        </template>
        <!-- estados de cuenta -->
        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="getColorCondicion(item.estado)" dark>
            <div v-if="item.estado == 'activo'"><span>Activo</span></div>
            <div v-if="item.estado == 'inactivo'"><span>Inactivo</span></div>
          </v-chip>
        </template>
      </v-data-table>
      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A
        INTENTAR.</v-snackbar
      >
      <v-snackbar v-model="snackbar" color="cyan darken-2" top :timeout="5000"
        >SE ENVIO UN CORREO AL USUARIO PARA CAMBIAR SU CONTRASEÑA.</v-snackbar
      >
    </v-flex>
  </v-layout>
</template>

<script>
import { dbAuth, dbRealtimeUsers } from "../main";
import XLSX from "xlsx"

export default {
  data() {
    return {
      dialog: false,
      usuarios: [],
      headers: [
        { text: "Opciones", value: "action", sortable: false },
        { text: "Nombre", value: "nombre", sortable: false },
        { text: "Cuenta", value: "cuenta", sortable: false },
        { text: "Correo", value: "correo", sortable: false },
        {
          text: "Id telegram",
          value: "idTelegram",
          align: "center",
          sortable: false,
        },
        { text: "Estado", value: "estado", sortable: false },
      ],
      search: "",
      editedIndex: -1,
      id: "",
      nombre: "",
      email: "",
      password: "",
      cuenta: "",
      itemsCuenta: ["Asistencia Regional", "Assa", "Futuro"],
      idTelegram: "",
      valida: 0,
      validaMensaje: [],
      addModal: 0,
      addAccion: 0,
      addNombre: "",
      addId: "",
      overlay: false,
      overlayNuevo: false,
      snackError: false,
      snackbar: false,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex == -1 ? "Nuevo" : "Actualizar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    listar() {
      let me = this;
      me.usuarios = [];
      dbRealtimeUsers.once("value").then(function (dataSnapshot) {
        dataSnapshot.forEach((value) => {
          me.usuarios.push(value.val());
        });
      });
    },
    crearUsuario() {
      let me = this;
      dbAuth
        .auth()
        .createUserWithEmailAndPassword(me.email, me.password)
        .then(function (response) {
          me.crearUsuarioDB(response.user.uid);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    crearUsuarioDB(id) {
      let me = this;
      dbRealtimeUsers
        .child(id)
        .set({
          id: id,
          correo: me.email,
          cuenta: me.cuenta,
          idTelegram: me.idTelegram,
          nombre: me.nombre,
          estado: "activo",
        })
        .then(function (response) {
          me.close();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    actualizar() {
      let me = this;
      dbRealtimeUsers
        .child(me.id)
        .update({
          nombre: me.nombre,
          cuenta: me.cuenta,
          idTelegram: me.idTelegram,
        })
        .then(function (response) {
          me.dialog = false;
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error);
          me.dialog = false;
        });
    },
    editItem(item) {
      //console.log(item.correo);
      this.editedIndex = 1;
      this.id = item.id;
      this.nombre = item.nombre;
      this.cuenta = item.cuenta;
      this.idTelegram = item.idTelegram;
      this.email = item.correo;
      this.dialog = true;
    },
    ActivarUsuario(item) {
      let me = this;

      dbRealtimeUsers
        .child(item.id)
        .update({ estado: "activo" })
        .then(function (response) {
          me.close();
          me.listar();
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    DesactivarUsuario(item) {
      let me = this;

      dbRealtimeUsers
        .child(item.id)
        .update({ estado: "inactivo" })
        .then(function (response) {
          me.close();
          me.listar();
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    getColorCondicion(condicion) {
      if (condicion == "activo") {
        return "green";
      } else {
        return "red";
      }
    },
    close() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.id = "";
      this.idRol = "";
      this.nombre = "";
      this.email = "";
      this.password = "";
      this.passwordAnt = "";
      this.actPassword = false;
      this.editedIndex = -1;
    },
    cambiarContraseñaFirebase() {
      dbAuth
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.snackbar = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    descargarExcel(){
      let data = XLSX.utils.json_to_sheet(this.usuarios);
      const workbook = XLSX.utils.book_new();
      const filename = "Usuarios";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>
